import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import fetchWithAuth from "../../util/fetchWithAuth";

const API_URL = process.env.REACT_APP_API_URL;

const useFetchWithAuth = (endpoint, options = {}, deps = []) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      if (!endpoint) {
        setData(null);
        setLoading(false);
        return;
      }
      const response = await fetchWithAuth(`${API_URL}${endpoint}`, options);

      if (response.status === 403) {
        throw new Error("Немає доступу");
      }

      if (!response.ok) throw new Error("Помилка запиту");

      const json = await response.json();
      setData(json);
    } catch (err) {
      if (err?.isAuthTransient) {
        setError(new Error("Тимчасова проблема мережі. Спробуйте оновити сторінку."));
      } else {
        setError(err);
      }

      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [endpoint, navigate, ...deps]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, error, refetch: fetchData };
};

export default useFetchWithAuth;
